export default __webpack_public_path__ + "static/media/reload-filters.41b36c01.svg";